import PrimaryButton from "components/buttons/PrimaryButton";
import { Uppdrag } from "types/uppdrag.type";
import { TransportSedelItem } from "./TransportSedelItem";
import { TransportSedelModal } from "./TransportSedelModal";
import { ShadowCard } from "components/ShadowCard";
import { useCreateTransportSedelLogic } from "./useCreateTransportSedelLogic";

type Props = {
  uppdrag: Uppdrag;
};
export const TransportSedelTab = ({ uppdrag }: Props) => {
  const noTransportSedels = uppdrag.transportSedelList.length === 0;
  const logic = useCreateTransportSedelLogic(uppdrag);
  if (noTransportSedels) {
    return (
      <ShadowCard className="flex flex-col items-center justify-center">
        <PrimaryButton onClick={logic.openModal}>
          + Ny Transportsedel
          <TransportSedelModal
            title={"Ny transportsedel - " + uppdrag.facility.customer.name}
            logic={logic}
          />
        </PrimaryButton>
      </ShadowCard>
    );
  }
  return (
    <>
      {uppdrag.transportSedelList.map((t) => (
        <TransportSedelItem key={t.uuid} transportSedel={t} uppdrag={uppdrag} />
      ))}
    </>
  );
};
